import { __extends, __assign } from 'tslib';
import React__default, { Component } from 'react';
import clsx from 'clsx';
import { propTypes, defaultProps } from './Switch.types.js';
import styles from './Switch.module.scss.js';

/** Boolean input. Preferred in 'enable/disable' situations. */
var Switch = /** @class */ (function (_super) {
    __extends(Switch, _super);
    function Switch() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleChange = function () {
            _this.props.onChange(!_this.props.checked);
        };
        _this.renderSlider = function () {
            var _a = _this.props, checked = _a.checked, withText = _a.withText, textWhenChecked = _a.textWhenChecked, textWhenUnchecked = _a.textWhenUnchecked, testId = _a.testId;
            return (React__default.createElement("span", { className: clsx(styles.Slider, checked && styles.Slider___checked, !withText && styles.Slider___basic, checked && !withText && styles.Slider___right), "data-testid": "visible-" + (_this.props['data-testid'] || testId) }, withText && (React__default.createElement("span", { className: clsx(styles.Slider_text, checked && styles.Slider_text___checked, !withText && styles.Slider_text___basic) }, checked ? textWhenChecked : textWhenUnchecked))));
        };
        return _this;
    }
    Switch.prototype.componentDidMount = function () {
        if (this.props.testId) {
            console.warn('DEPRECATION WARNING: The `testId` prop is deprecated and support for it will be removed soon. Please use `data-testid` instead.');
        }
    };
    Switch.prototype.render = function () {
        var _a = this.props, checked = _a.checked, withText = _a.withText, disabled = _a.disabled, testId = _a.testId;
        var labelClassName = clsx(styles.Switch, disabled && styles.Switch___disabled, !withText && styles.Switch___basic);
        return (React__default.createElement("label", { className: labelClassName },
            React__default.createElement("input", { type: "checkbox", onChange: this.handleChange, checked: checked, disabled: disabled, "data-testid": this.props['data-testid'] || testId, className: styles.Switch_input }),
            this.renderSlider()));
    };
    Switch.displayName = 'Switch';
    Switch.propTypes = propTypes;
    Switch.defaultProps = __assign({}, defaultProps);
    return Switch;
}(Component));

export { Switch as default };
